"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFamilyOrIndividual = void 0;
var IFamilyOrIndividual;
(function (IFamilyOrIndividual) {
    IFamilyOrIndividual["Family"] = "family";
    IFamilyOrIndividual["Individual"] = "individual";
})(IFamilyOrIndividual || (exports.IFamilyOrIndividual = IFamilyOrIndividual = {}));
//# sourceMappingURL=family-or-individual.js.map